import {useDevice} from 'platform/foundation';

export function useIsMobileView(): boolean {
  const device = useDevice();
  return device === 'mobile';
}
